import UpgradeThanks from './UpgradeThanks';

export default UpgradeThanks;
